(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/dades/dades.tpl.html',
            controller: 'EntitatsMainSubmainDadesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());
